import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import tileReducer from './tileReducer';
import sessionReducer from './sessionReducer';
import statsReducer from './statsReducer';
import inventoryReducer from './inventoryReducerV2';
import dsoReducer from './dsoReducer';
import messageReducer from './messageReducer';
import supplierReducer from './supplierReducer';
import spinnerReducer from './spinnerReducer';
import ordersReducer from './ordersReducer';
import errorReducer from './errorReducer';
import drawerReducer from './drawerReducer';
import aiSkuMappingReducer from './aiSkuMappingsReducer';

const config = {
	key: 'root',
	storage,
	blacklist: ['spinnerReducer', 'aiSkuMappings'],
};

export default persistCombineReducers(config, {
	tiles: tileReducer,
	session: sessionReducer,
	stats: statsReducer,
	inventory: inventoryReducer,
	dso: dsoReducer,
	message: messageReducer,
	supplier: supplierReducer,
	spinner: spinnerReducer,
	orders: ordersReducer,
	error: errorReducer,
	drawer: drawerReducer,
	aiSkuMappings: aiSkuMappingReducer
});
